export const environment = {
  production: false,
  apiUrl: 'https://demo.blockchain.dx-compliance.com/v1'
};
